const cheerio = require("cheerio");
const parseHeadCodeInjection = (html) => {
    const parsedHtml = cheerio.load(html);

    const children = parsedHtml("script");

    const codeInjObj = {};

    children.each((i, script) => {
        codeInjObj[i] = { ...codeInjObj[i], html: parsedHtml(script).html() };
        codeInjObj[i] = { ...codeInjObj[i], attr: parsedHtml(script).attr() };
    });

    const arrayOfCodeInjObj = Object.values(codeInjObj);
    return arrayOfCodeInjObj;
};

function setAttributes(el, attrs) {
    for (const key in attrs) {
        if (key) {
            el.setAttribute(key, attrs[key]);
        }
    }
}
const parseFootCodeInjection = (html) => {
    const parsedHtml = cheerio.load(html);
    const divs = parsedHtml("div");
    const styles = parsedHtml("style");
    const scripts = parsedHtml("script");

    const allTags = [divs, styles, scripts];
    const allCodeInjObjArr = allTags.map((tag) => {
        const codeInjObj = {};
        tag.each((i, child) => {
            codeInjObj[i] = { ...codeInjObj[i], name: child.name };
            codeInjObj[i] = {
                ...codeInjObj[i],
                html: parsedHtml(child).html(),
            };
            codeInjObj[i] = {
                ...codeInjObj[i],
                attr: parsedHtml(child).attr(),
            };
        });
        return Object.values(codeInjObj);
    });
    return allCodeInjObjArr.flat();
};

module.exports = {
    parseHeadCodeInjection,
    parseFootCodeInjection,
    setAttributes,
};
